var _polygon, _path, _polygon2, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _circle3, _path9, _path10, _path11, _path12, _path13, _polygon3, _circle4, _circle5, _circle6, _polygon4, _rect, _rect2, _path14, _path15, _rect3, _path16, _path17, _path18, _path19, _path20, _rect4, _rect5, _rect6, _rect7, _circle7, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbstract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 904.88583,
    height: 742,
    viewBox: "0 0 904.88583 742",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "686.055 724.756 670.765 724.755 663.491 665.781 686.057 665.782 686.055 724.756",
    fill: "#ffb6b6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M837.51088,818.57692l-49.30025-.00183v-.62357a19.19007,19.19007,0,0,1,19.189-19.18872h.00122l30.11091.00122Z",
    transform: "translate(-147.55709 -79)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "801.699 711.547 787.146 716.236 762.135 662.335 783.614 655.414 801.699 711.547",
    fill: "#ffb6b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M957.51324,803.4578l-46.92469,15.11912-.19125-.59352a19.19005,19.19005,0,0,1,12.37881-24.14934l.00116-.00038,28.66-9.23414Z",
    transform: "translate(-147.55709 -79)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 809.34809,
    cy: 504.31001,
    r: 19.09176,
    fill: "#FDE047"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M981.90481,618.14334c-.34382.18518-.684.35878-1.02442.532l-40.31-74.84561c.332-.18889.66413-.37741,1.008-.56259a42.52255,42.52255,0,0,1,40.32646,74.8762Z",
    transform: "translate(-147.55709 -79)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M944.68387,580.11939,939.0498,501.9506l1.07159-26.08994-21.95992,4.88623,8.08884,102.42635a11.44566,11.44566,0,1,0,18.43356-3.05385Z",
    transform: "translate(-147.55709 -79)",
    fill: "#ffb7b7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M845.31021,511.217l-1.39631-26.19047-14.09344-11.45092L827.874,498.748l-51.88329,59.9845a11.44505,11.44505,0,1,0,13.25561,11.29506c0-.15408-.017-.30381-.023-.45639Z",
    transform: "translate(-147.55709 -79)",
    fill: "#ffb7b7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M847.83725,502.83344,803.55709,559l-15-16,31-45,19.42316-85.3219a9.00378,9.00378,0,0,1,5.25966-4.68893,8.86575,8.86575,0,0,1,6.92027.4972l.25118.12731Z",
    transform: "translate(-147.55709 -79)",
    fill: "#FDE047"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M923.94463,556l-14.066-97.7742.02322-.09032L924.34756,401.348l1.35352-.15742A15.77033,15.77033,0,0,1,942.874,413.67543L943.94463,559Z",
    transform: "translate(-147.55709 -79)",
    fill: "#FDE047"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M928.38283,386.015H855.27312v-33.0315a36.55486,36.55486,0,1,1,73.10971,0Z",
    transform: "translate(-147.55709 -79)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 890.98556,
    cy: 357.12825,
    r: 29.87879,
    transform: "translate(2.69469 888.62749) rotate(-61.33681)",
    fill: "#ffb7b7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 757.85329,
    cy: 232.88951,
    r: 19.88951,
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M936.55709,358.709H858.79648v-.44042c0-20.15652,17.44151-36.55486,38.8803-36.55486s38.88031,16.39834,38.88031,36.55486Z",
    transform: "translate(-147.55709 -79)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M837.30468,774.28026l-28.88989-2.06348-.03858-.42285c-12.66089-138.21338-5.4768-229.499,20.22388-257.064l7.25195-13.56592-3.9707-22.83057c-10.60352-27.92969,7.20605-48.35986,8.55225-49.84473l5.74072-17.22168a6.51128,6.51128,0,0,1,5.50488-4.41113l78.01514-7.97851.05078.49755-.05078-.49755a6.49986,6.49986,0,0,1,7.14306,5.97607l.00684.0918-.02588.08838-28.43847,95.76806,2.49267,32.40772L944.436,765.13866,915.52978,771.333l-.13379-.43945L862.05761,596.06248Z",
    transform: "translate(-147.55709 -79)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M764.55709,636.5h-610a6.50745,6.50745,0,0,1-6.5-6.5V86a6.50745,6.50745,0,0,1,6.5-6.5h610a6.50753,6.50753,0,0,1,6.5,6.5V630A6.50753,6.50753,0,0,1,764.55709,636.5Z",
    transform: "translate(-147.55709 -79)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M356.24944,103.43079V244.01555H355.963a70.29238,70.29238,0,0,1,0-140.58476Z",
    transform: "translate(-147.55709 -79)",
    fill: "#FDE047"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M340.34247,135.11562v77.2151h-.15733a38.60755,38.60755,0,0,1,0-77.2151Z",
    transform: "translate(-147.55709 -79)",
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "312.543 281 100.146 281 100.146 93.723 138.114 93.723 138.114 95.723 102.146 95.723 102.146 279 312.543 279 312.543 281",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.1804,
    cy: 309.07154,
    r: 19.09176,
    fill: "#FDE047"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 519.08087,
    cy: 493.91446,
    r: 19.09176,
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.79782,
    cy: 278.69829,
    r: 19.09176,
    fill: "#FDE047"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "312.543 280.434 360.272 280.434 360.272 232.705 264.813 232.705 264.813 328.163 312.543 328.163 312.543 280.434",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 414.94401,
    y: 40.05132,
    width: 209.14152,
    height: 26.03421,
    fill: "#e4e4e4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 414.94401,
    y: 96.45879,
    width: 209.14152,
    height: 26.03421,
    fill: "#e4e4e4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M709.16051,264.84292c0,.39053-.00848.77236-.01738,1.1542H624.13278c-.0089-.38184-.01737-.76367-.01737-1.1542a42.52255,42.52255,0,0,1,85.0451,0Z",
    transform: "translate(-147.55709 -79)",
    fill: "#e4e4e4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M709.16051,567.42123c0,.39052-.00848.77236-.01738,1.1542H624.13278c-.0089-.38184-.01737-.76368-.01737-1.1542a42.52255,42.52255,0,0,1,85.0451,0Z",
    transform: "translate(-147.55709 -79)",
    fill: "#e4e4e4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 518.08081,
    y: 228.36523,
    width: 2,
    height: 217.42334,
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M421.04853,546.88025a65.08773,65.08773,0,0,1-64.79909,65.08554V481.79471A65.08773,65.08773,0,0,1,421.04853,546.88025Z",
    transform: "translate(-147.55709 -79)",
    fill: "#FDE047"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M766.43575,639H153.76387a6.21411,6.21411,0,0,1-6.20678-6.207V85.207A6.21411,6.21411,0,0,1,153.76387,79H766.43575a6.21412,6.21412,0,0,1,6.20679,6.207V632.793A6.21412,6.21412,0,0,1,766.43575,639ZM153.76387,81a4.21159,4.21159,0,0,0-4.20678,4.207V632.793A4.21159,4.21159,0,0,0,153.76387,637H766.43575a4.21167,4.21167,0,0,0,4.20679-4.207V85.207A4.21167,4.21167,0,0,0,766.43575,81Z",
    transform: "translate(-147.55709 -79)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M355.24947,245.01953V102.42676l1.004.0039a71.29307,71.29307,0,0,1,0,142.585Zm2-140.57764v138.5625a69.29321,69.29321,0,0,0,0-138.5625Z",
    transform: "translate(-147.55709 -79)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M357.24947,612.96582H355.963a66.08545,66.08545,0,1,1,0-132.1709h1.2865Zm-2-130.167a64.08551,64.08551,0,0,0,0,128.16308Z",
    transform: "translate(-147.55709 -79)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M666.6379,308.36523a43.28328,43.28328,0,0,1-43.50489-42.3413l-.02734-1.02686h87.06445l-.02734,1.02686A43.283,43.283,0,0,1,666.6379,308.36523Zm-41.46582-41.36816a41.5217,41.5217,0,0,0,82.93164,0Z",
    transform: "translate(-147.55709 -79)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 372,
    width: 623.08545,
    height: 2,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 185.99707,
    width: 623.08545,
    height: 2,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 415.39038,
    y: 1,
    width: 2,
    height: 558,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 207.69226,
    y: 1,
    width: 2,
    height: 558,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.92379,
    cy: 466.14463,
    r: 19.09176,
    fill: "#FDE047"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1051.44291,821h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-147.55709 -79)",
    fill: "#cacaca"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M721.97734,818.98441c5.62838-18.13749.16075-38.76475-12.67716-52.54826a50.03693,50.03693,0,0,0-12.496-9.75441,1.50667,1.50667,0,0,0-1.81774,2.35586l2.5707,2.78174V759.698c-4.97606,4.64241-14.04638,1.101-14.95058-5.49862a11.31659,11.31659,0,0,1,3.42285-9.36476,10.74267,10.74267,0,0,1,10.20109-2.53135,13.348,13.348,0,0,1,8.74935,6.92766,14.767,14.767,0,0,1,.41642,11.19372c-2.74369,8.01876-11.49776,11.78914-19.48606,9.89977-8.15254-1.92822-13.99436-9.614-14.26081-17.91466a19.75346,19.75346,0,0,1,12.6194-18.62539c8.55783-3.16183,17.8492-.00063,25.07752,4.88676a56.44761,56.44761,0,0,1,17.57858,20.01556,57.753,57.753,0,0,1,7.07158,25.17383c.23295,7.25524-1.3078,15.497-6.65822,20.79705a16.4303,16.4303,0,0,1-4.38134,3.07615l1.51416,2.59041a56.674,56.674,0,0,0,27.98132-54.95041,57.41367,57.41367,0,0,0-5.47031-18.85381c-.84769-1.73431-3.43578-.2154-2.59041,1.51416a53.87588,53.87588,0,0,1,4.69032,32.384,53.6037,53.6037,0,0,1-26.12508,37.31569c-1.69095.97135-.20395,3.43316,1.51416,2.59041,8.07832-3.96249,11.6019-12.92989,12.37857-21.42363.88675-9.69762-1.63541-19.76923-5.71991-28.51533A60.92244,60.92244,0,0,0,712.198,737.01962c-8.04352-5.86637-18.93911-9.74427-28.72673-6.12806-8.75369,3.23419-15.117,12.09946-14.82189,21.51822.2962,9.45307,6.82361,18.34609,16.10063,20.71841,9.25367,2.36635,19.37327-1.71312,23.1035-10.76088a17.98912,17.98912,0,0,0,.35682-13.1791,16.20638,16.20638,0,0,0-9.20892-9.1364,14.34294,14.34294,0,0,0-12.76667.8315,14.52122,14.52122,0,0,0-6.55349,10.146,11.6174,11.6174,0,0,0,4.01712,10.80743,13.24166,13.24166,0,0,0,10.97121,2.64384,10.67206,10.67206,0,0,0,5.00886-2.66126,1.52536,1.52536,0,0,0,0-2.12132l-2.5707-2.78174L695.29,759.27215c15.72577,8.63312,25.56863,26.19162,25.9,43.9961a47.262,47.262,0,0,1-2.10547,14.91864c-.5735,1.84811,2.32153,2.63855,2.89284.79752Z",
    transform: "translate(-147.55709 -79)",
    fill: "#f0f0f0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstract);
export default __webpack_public_path__ + "static/media/abstract.f0fb56dd6f3f6d25f6259d8c9f28dd4c.svg";
export { ForwardRef as ReactComponent };